export default class AdminLabUploads {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminLabUploadsRoute}`, {
      params
    })
  }

  fetch(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminLabUploadsRoute}/${id}`, {})
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminLabUploadsRoute}/${id}`, payload, {})
  }
  
  delete(id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.adminLabUploadsRoute}/${id}`, {})
  }

  deleteForAll(id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.adminLabUploadsRoute}/${id}/delete-for-all`, {})
  }
}
